import Vue from 'vue';
import tagEdit from './tagEdit.vue';

const defaults = {
    modal: true, //是否需要遮罩层
    closeOnClickModal: true, //是否可以通过点击 modal 关闭 Dialog
    confirm() {}, //Dialog确定的回调事件
    cancel() {}, //Dialog关闭的回调事件,
}

const $ = (options = {}) => {
    //当前 Vue 实例是否运行于服务器。
    if (Vue.prototype.$isServer) return;
    //merge 默认参数
    options = Object.assign({}, defaults, options);
    //生成一个Vue的子类
    const FileEditConstructor = Vue.extend(tagEdit)
    //生成子类的实例
    let instance = new FileEditConstructor({
        el: document.createElement('div'), //将实例挂载到创建的div上
        data: options
    })

    //将此div加入全局挂载点内部
    document.body.appendChild(instance.$el);

    //初始化后立即显示弹窗
    Vue.nextTick(() => {
        instance.show = true;
    })
    return instance;
}

export default $;